module.exports = __webpack_public_path__ + "img/warm-up.5ce437ed.jpg";